export default __webpack_public_path__ + "static/media/drive-thru-logo.841113b5.png";